<div class="sub-content">
  <div class="header">
    <div class="title">
      Select users
    </div>
    <div class="controls">
      <button mat-raised-button color="primary" class="btn btn-blue add-btn" [disabled]="!addButtonDiable"
              (click)="subStep._returnOutput('userNames', subStep.dataSource, 'append', { isChecked: true }); ">ADD</button>
    </div>
  </div>

  <div class="vertical-dotted-line"></div>
  <div class="datasource_filter"><mat-icon>search</mat-icon>
    <input autocomplete="off" class="datasource_filter" placeholder="Search for users" #filterInput="ngModel" [(ngModel)]="subStep.filterText"
           (ngModelChange)="filterUsersList($event)"/></div>
  <div class="datasource_list">
    <div class="datasource"
         *ngFor="let member of filteredMemberGroups"
         (click)="flipValue(member) "
         [ngClass]="{selectedItem: member.isChecked}">
      <div class="icon"><mat-icon>check_circle_outline</mat-icon></div>
      <img class="avatar" [src]="userService.getGravatarUrl(member.email)"/>
      <div class="member-info">
        <b>{{member.firstName}} {{member.lastName}}</b>
        <span>{{member.email}}</span>
      </div>
    </div>
  </div>
</div>
